// src/pages/client/CVtheque.jsx
import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import Iframe from 'react-iframe';
// Remplacer l'import de l'image PNG par le SVG
import CalltoAction from '../../components/client/CalltoAction';
import { Link } from 'react-router-dom';


const CVtheque = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />

      {/* Section Hero avec texte à gauche et SVG à droite */}
      <div className="py-16 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Texte à gauche */}
            <div className='text-white'>
              <div className='mb-6'>
                  <h1 className="text-5xl font-bold  mb-6 leading-tight">
                    CVthèque connectée
                 </h1>
              </div>
              <div className=' mb-8 '>
                <p className="text-xl  leading-relaxed">
                  Gérez toutes vos relations candidats dans un seul endroit avec notre CRM intuitif et connecté à tous vos outils de recrutement
              </p>
              </div>
              
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                 <button className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition">
                  Commencer gratuitement
                </button>
                </Link>
               
                
              </div>
            </div>
            
            {/* SVG à droite */}
            <div className="flex justify-center ">
              <img 
                src='/Image/fonctionnalités/CRM.png'
                alt="Interface Jobrise CVthèque" 
                className="w-full max-w-2xl h-auto 
                          hover:scale-105 hover:rotate-1 
                          transition-all duration-500 
                          drop-shadow-2xl hover:drop-shadow-[0_25px_25px_rgba(0,0,0,0.15)]
                          cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800">
                            Un CRM Pensé pour les Recruteurs

            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Centralisez, suivez et optimisez toutes vos interactions candidats avec une interface intuitive et connectée
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Suivi des Interactions</h3>
              <p className="text-slate-600">
                Historique complet de tous vos échanges avec les candidats : emails, appels, notes, entretiens. Tout centralisé en un clic.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Pipeline Intelligent</h3>
              <p className="text-slate-600">
                Visualisez et gérez vos candidats à travers votre processus de recrutement avec notre système de pipeline drag & drop intuitif.              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Parsing CV Automatique</h3>
              <p className="text-slate-600">
                Extraction automatique des informations des CV (nom, email, compétences, expérience) pour un gain de temps considérable.
              </p>              
            </div>
          </div>

          
          
          <CalltoAction/>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CVtheque;